import { PredictionData } from "@/interfaces/liveGamesType";
import { api } from "@/services/api";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

export const fetchGetPredictions = (
  matchId: string,
  options?: Partial<UseQueryOptions<PredictionData>>
) => {
  const response = useQuery({
    queryKey: ["football/getPrediction", matchId],
    queryFn: async () => {
      const res = await api.get(`/football/getPrediction`,{
        params: {
          matchId: matchId,
        },
      });
      if(res.data.error){
        return null;
      }
      return res.data.data[0];
    },
    ...options,
  });

  return response;
};
